import React from "react";

function Footer() {
  return (
      <footer className="flex justify-center items-center py-4 w-[100vw]">
        <p className="text-[#252525] text-[12px]">
          &copy; {new Date().getFullYear()} Parify Packaging Collection Creator. All Rights Reserved.
        </p>
      </footer>
  ); 
}

export default Footer;
